import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

const input = "w-full border border-linen bg-white px-4 py-3 text-sm outline-none focus:border-pitch transition-colors";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  if (!token) return (
    <AuthShell title="Invalid Link" subtitle="Account recovery" footer={<Link to="/forgot-password" className="text-pitch border-b border-pitch pb-0.5">Request a new link</Link>}>
      <p className="text-sm text-charcoal/70">This reset link is invalid or has expired.</p>
    </AuthShell>
  );

  return (
    <AuthShell title="New Password" subtitle="Account recovery" footer={<Link to="/login" className="text-pitch border-b border-pitch pb-0.5">Back to Sign In</Link>}>
      <form onSubmit={submit} className="space-y-4">
        {error && <div className="bg-vermilion/10 border border-vermilion/30 text-vermilion text-sm px-4 py-3">{error}</div>}
        <input required type="password" placeholder="New password (min 6 characters)" value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="reset-password" />
        <button type="submit" disabled={loading} data-testid="reset-submit"
          className="w-full bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.2em] py-4 hover:bg-charcoal transition-colors disabled:opacity-50">
          {loading ? "Resetting…" : "Reset Password"}
        </button>
      </form>
    </AuthShell>
  );
}
